var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradingLevels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* Saya buang style .garisan-tepi sebab dah tak pakai */\n    .kotak { fill: white; stroke: black; stroke-width: 2; }\n    .tulisan { font-family: sans-serif; font-weight: bold; font-size: 14px; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10 15 L 0 5 L 0 25 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 30,
    rx: 5,
    className: "kotak"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    className: "tulisan"
  }, "SL : 4611.913"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10 15 L 0 5 L 0 25 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 30,
    rx: 5,
    className: "kotak"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    className: "tulisan"
  }, "Re Entry : 4601.990"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10 15 L 0 5 L 0 25 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 30,
    rx: 5,
    className: "kotak"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    className: "tulisan"
  }, "Entry : 4596.190"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10 15 L 0 5 L 0 25 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 30,
    rx: 5,
    className: "kotak"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    className: "tulisan"
  }, "TP WAJIB : 4579.651"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -10 15 L 0 5 L 0 25 Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 30,
    rx: 5,
    className: "kotak"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    className: "tulisan"
  }, "TP 1 : 4543.265"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingLevels);
export default __webpack_public_path__ + "static/media/trading-levels.0e08008905b274f1f157d5a357f45f61.svg";
export { ForwardRef as ReactComponent };